import { Component, OnInit, OnDestroy, SimpleChanges, OnChanges, AfterViewInit } from '@angular/core';
import { ActivatedRoute, Router, NavigationStart, NavigationEnd, NavigationError } from '@angular/router';
import { IssueService } from '../../services/issue.service';
import swal from 'sweetalert2';

@Component({
    selector: 'issues-summary',
    templateUrl: './issues-summary.component.html'
})
export class IssuesSummaryComponent implements AfterViewInit, OnDestroy {

    clientId: number = 1;
    subscriptions: any[] = [];

    constructor(private route: ActivatedRoute,
        private router: Router,
        private issueService: IssueService) { }

    ngAfterViewInit() {
        this.subscriptions.push(this.route.queryParams.subscribe(queryParams => {
            this.onInitialise();
        }));
    }

    onInitialise() {
        this.clientId = this.route.parent.parent.snapshot.params['clientId'];
    }

    ngOnDestroy() {
        this.subscriptions.forEach(s => s.unsubscribe());
    }

    onHistoryInfoClick() {
        swal({
            title: 'Issue history',
            html: '<p style="text-align: left;">The issue data and widgets help us to understand where potential concerns in your portfolio may lie.</p>\
                   <p style="text-align: left;">This might include consumers in debt, bills being estimated or consumers beyond emergency credit.</p>\
                   <p style="text-align: left;">The next few pages will explain in detail how your portfolio is performing.</p>\
                   <p style="text-align: left;">For ways to make improvement, contact our customer services team, we are always here to help.</p>',
            confirmButtonText: 'Close',
            confirmButtonColor: '#00539f'
        });
    }
}
